module.exports = __webpack_public_path__ + "static/media/pic7.dd090dc6.jpg";